export const mainColor = '#d8704b';

export const mapBoxDrawnLayerStyle = [
	// Polygon fill color
	{
		id: 'gl-draw-polygon-fill',
		type: 'fill',
		filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
		paint: {
			'fill-color': mainColor,
			'fill-opacity': 0.4
		}
	},
	// Polygon outline color
	{
		id: 'gl-draw-polygon-stroke-active',
		type: 'line',
		filter: ['all', ['==', '$type', 'Polygon'], ['!=', 'mode', 'static']],
		paint: {
			'line-color': mainColor,
			'line-width': 2
		}
	},
	// Vertex points
	{
		id: 'gl-draw-polygon-and-line-vertex-halo-active',
		type: 'circle',
		filter: [
			'all',
			['==', 'meta', 'vertex'],
			['==', '$type', 'Point'],
			['!=', 'mode', 'static']
		],
		paint: {
			'circle-radius': 7,
			'circle-color': mainColor
		}
	},
	{
		id: 'gl-draw-polygon-and-line-vertex-active',
		type: 'circle',
		filter: [
			'all',
			['==', 'meta', 'vertex'],
			['==', '$type', 'Point'],
			['!=', 'mode', 'static']
		],
		paint: {
			'circle-radius': 3,
			'circle-color': mainColor
		}
	},
	{
		id: 'gl-draw-polygon-midpoint',
		type: 'circle',
		filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'midpoint']],
		paint: {
			'circle-radius': 4
		}
	}
];

export const zoomToSite = (site, event, parent) => {
	window.scrollTo(0, 0);
	let thisSite = parent.props.sites.filter(({ id }) => id === site.id)[0];

	if (thisSite.lat != null && thisSite.lon != null) {
		parent.setState({
			listMapLat: thisSite.lat,
			listMapLong: thisSite.lon,
			listMapZoom: [13]
		});
	}
};
